import { render, staticRenderFns } from "./FrontPageLinksToConsumers.vue?vue&type=template&id=48ba0566&scoped=true&"
import script from "./FrontPageLinksToConsumers.vue?vue&type=script&lang=ts&"
export * from "./FrontPageLinksToConsumers.vue?vue&type=script&lang=ts&"
import style0 from "./FrontPageLinksToConsumers.vue?vue&type=style&index=0&id=48ba0566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba0566",
  null
  
)

export default component.exports